import { createClient } from "@supabase/supabase-js";
import { env } from "@/lib/env";

/**
 * Supabase browser client.
 *
 * Uses the anon key (RLS enforces ownership server-side via `web_owner_read`
 * policies — see UC-10.02). The whitelist is enforced client-side in the
 * `_authenticated` route guard (`beforeLoad`); RLS is the real boundary.
 */
export const supabase = createClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Supabase auto-detects `?code=` in URL on module load and exchanges
    // it for a session. We let it do that — our `auth.callback` route
    // simply waits for the resulting session and navigates onward.
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});
